const CLS = { Amazing: "amazing", Great: "great", Good: "good", "Below Good": "below" };

export const GradeResult = ({ r, reading, testid }) => (
  <div className="lg-grade" data-testid={`${testid}-result`}>
    <div style={{ display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap", marginBottom: 6 }}>
      <span className={`lg-gradepill ${CLS[r.grade]}`} data-testid={`${testid}-suggested`}>{r.grade}</span>
      <span style={{ fontSize: 14 }} data-testid={`${testid}-score`}>
        {r.mode === "pve" ? <>Score <b>{r.score ?? "—"}%</b></> : <>Initial Charge <b>{r.score != null ? `${r.score}s` : "not read"}</b></>}
      </span>
      {reading?.confidence && <span style={{ fontSize: 12, color: "var(--muted)" }}>Reading confidence: {reading.confidence}</span>}
    </div>
    <ul style={{ fontSize: 13, margin: "4px 0 0 18px", listStyle: "disc" }}>
      {(r.notes || []).map((n) => <li key={n}>{n}</li>)}
    </ul>
    {reading?.problems?.length > 0 && <p className="lg-err" style={{ fontSize: 13, marginTop: 6 }}>{reading.problems.join(" · ")}</p>}
  </div>
);
